import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterGem,
} from "@dndModels";
import { DisablableOption } from "@models";

import API from "@dndUtilities/system_api";

import StringBox from "@components/input/strings/StringBox";

import SelectStringBox from "@components/input/selects/SelectStringBox";

interface Props {
  character: Character;
  char_item: CharacterGem;
  // onChange: (repopulate: boolean, close: boolean) => void;
}

const api = API.getInstance();

export default function CharacterGemControls({
  character,
  char_item,
  // onChange,
}: Props) {
  const [ping, setPing] = useState(false);

  const enabled = api.user && (character.owner_id === api.user._id || (character.campaign && character.campaign.owner_id === api.user._id));

  if (char_item.sizes.length > 0) {
    return (
      <Grid
        container
        spacing={0}
        direction="row"
        size={{
          xs: 12
        }}>
        <Grid
          size={{
            xs: 6
          }}>
          <SelectStringBox
            name="Gem Size"
            options={char_item.sizes.map(o => {
              const opt: DisablableOption = {
                id: o.true_id, text: o.name
              };
              return opt;
            })}
            value={char_item.gem_size_id}
            onChange={(changed: string) => {
              const new_obj = char_item as CharacterGem;
              const size = new_obj.sizes.find(o => o.true_id === changed);
              // debugger;
              if (size) {
                new_obj.gem_size_id = changed;
                new_obj.cost = size.cost;
                new_obj.weight = size.weight;
              }
              // onChange(false, false);
              character.changed();
              character.subscription_holder.resourcesChanged();
            }}
          />
        </Grid>
        {/* <Grid item xs={6}>
          <StringBox
            name="Quantity"
            value={ `${char_item.count}` }
            type="number"
            onBlur={(changed: string) => {
              const new_obj = char_item as CharacterGem;
              new_obj.count = +changed;
              // onChange(false, false);
              character.changed();
              character.subscription_holder.resourcesChanged();
              setPing(!ping);
            }}
          />
        </Grid> */}
      </Grid>
    );
  } else {
    return (
      <Grid
        container
        spacing={0}
        direction="row"
        size={{
          xs: 12
        }}>
        <Grid
          size={{
            xs: 4
          }}>
          <StringBox
            name="Cost (in gp)"
            disabled={!enabled}
            value={char_item.cost}
            type="number"
            onBlur={(changed: string) => {
              const new_obj = char_item as CharacterGem;
              new_obj.cost = +changed;
              // onChange(false, false);
              character.changed();
              character.subscription_holder.resourcesChanged();
              setPing(!ping);
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 4
          }}>
          <StringBox
            name="Weight (in lbs)"
            disabled={!enabled}
            value={char_item.weight}
            type="number"
            onBlur={(changed: string) => {
              const new_obj = char_item as CharacterGem;
              new_obj.weight = +changed;
              // onChange(false, false);
              character.changed();
              character.subscription_holder.resourcesChanged();
              setPing(!ping);
            }}
          />
        </Grid>
        {/* <Grid item xs={4}>
          <StringBox
            name="Quantity"
            value={ `${char_item.count}` }
            type="number"
            onBlur={(changed: string) => {
              const new_obj = char_item as CharacterGem;
              new_obj.count = +changed;
              // onChange(false, false);
              character.changed();
              character.subscription_holder.resourcesChanged();
              setPing(!ping);
            }}
          />
        </Grid> */}
      </Grid>
    );
  }
}
